export default function toggleVeteranMode () {
    const priceToggle = document.getElementById('priceToggle');
    const prices = document.querySelectorAll('.packages__cardPrice');

    if (!priceToggle || prices.length === 0) return;

    function updatePrices (isVeteran) {
        prices.forEach(priceEl => {
            priceEl.classList.toggle('veteran-active', isVeteran);
        });
    }

    const params = new URLSearchParams(window.location.search);
    const isVeteran = params.get('veteran') === 'true';

    priceToggle.checked = isVeteran;
    updatePrices(isVeteran);
    updateBlocksVisibility(isVeteran);

    if (window.location.hash) {
        setTimeout(() => {
            const targetId = window.location.hash.substring(1);
            const targetEl = document.getElementById(targetId);
            if (targetEl) {
                targetEl.scrollIntoView({ behavior: 'smooth' });
            }
        }, 300);
    }

    priceToggle.addEventListener('change', function () {
        updatePrices(this.checked);
        updateBlocksVisibility(this.checked);
    });

    document.querySelectorAll('.veteran-link').forEach(link => {
        link.addEventListener('click', function (event) {
            const isOnPricingPage = window.location.pathname.includes('pricing.html');

            if (isOnPricingPage) {
                event.preventDefault();

                priceToggle.checked = true;
                priceToggle.dispatchEvent(new Event('change'));

                const targetEl = document.getElementById('prices');
                if (targetEl) {
                    targetEl.scrollIntoView({ behavior: 'smooth' });
                }

                const newUrl = `${window.location.pathname}?veteran=true#prices`;
                window.history.replaceState(null, '', newUrl);
            }
        });
    });

    function updateBlocksVisibility (isVeteran) {
        document.querySelectorAll('[data-hide-on-veteran]').forEach(block => {
            block.classList.toggle('hidden', isVeteran);
        });
    }
}